import { featureFlags } from 'client/utils/feature-flags';
import { serializeError } from 'client/utils/serialize-error';
import { loggerMethods } from './logger-utils';

function log(level) {
  return (data, message) => {
    const { err, ...meta } = data ?? {};

    // console.log it. note: chrome shows pretty errors only if the error is a top level arg
    const consoleArgs = [`[logger] ${message}`];
    if (Object.keys(meta).length > 0) {
      consoleArgs.push(...['\n', meta]);
    }
    if (err) {
      consoleArgs.push(...['\n ', err]);
    }
    // eslint-disable-next-line no-console
    console[level](...consoleArgs);

    const newrelicEnabled = featureFlags.get('newrelic');
    if (!newrelicEnabled) {
      return;
    }
    if (level === 'error') {
      // send to newrelic `JavaScriptError` table...
      const errorObj = err instanceof Error ? err : new Error(message);
      if (window.newrelic?.noticeError) {
        window.newrelic.noticeError(errorObj, { ...meta, loggerMessage: message });
      } else {
        // eslint-disable-next-line no-console
        console.warn('window.newrelic.noticeError is not available, above error will not be sent to NR js errors.');
      }
    }
    if (window.newrelic?.log) {
      // send to newrelic `Log` table...
      let customAttributes = meta;
      if (err) {
        customAttributes = { ...customAttributes, err: serializeError(err) };
      }
      window.newrelic.log(message, {
        level,
        customAttributes,
      });
    } else {
      // eslint-disable-next-line no-console
      console.warn('window.newrelic.log is not available, above log will not be sent to NR logs');
    }
  };
}

// Creating a client logger
export const clientLogger = loggerMethods.reduce((acc, level) => {
  acc[level] = log(level);
  return acc;
}, {});
